// useServiceData.js
import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../../config";

const useServiceData = (subserviceName) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios
      .post(`${API_URL}/layout/service`, { subservice: subserviceName })
      .then((res) => {
        console.log("response", res);
        setData(res?.data?.data?.[0]);
      })
      .catch((err) => console.error(err));
  }, [subserviceName]);

  return data;
};

export default useServiceData;
